module.exports = __webpack_public_path__ + "img/profile_moderate.70aa0761.png";